export const SET_AVAILABLE_LICENSES = 'SET_AVAILABLE_LICENSES';
export const RESET_AVAILABLE_LICENSES = 'RESET_AVAILABLE_LICENSES';
